const textIcon = () =>{

    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M8 7H16M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
 </svg>
    )
}


const likertIcon = () =>{

    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M9.49999 3L6.49999 21M17.5 3L14.5 21M20.5 8H3.5M19.5 16H2.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
 </svg>)

}

const multiSelectIcon = () =>{
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
 </svg>
    )
}

const dropdownIcon = () =>{
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
 <path d="M17.5 11H12.5M17.5 15H12.5M17.5 7H12.5M9 3L9 21M7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
 </svg>
    )
}


const informationIcon = () =>{
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M20 10.5V6.8C20 5.11984 20 4.27976 19.673 3.63803C19.3854 3.07354 18.9265 2.6146 18.362 2.32698C17.7202 2 16.8802 2 15.2 2H8.8C7.11984 2 6.27976 2 5.63803 2.32698C5.07354 2.6146 4.6146 3.07354 4.32698 3.63803C4 4.27976 4 5.11984 4 6.8V17.2C4 18.8802 4 19.7202 4.32698 20.362C4.6146 20.9265 5.07354 21.3854 5.63803 21.673C6.27976 22 7.11984 22 8.8 22H12M14 11H8M10 15H8M16 7H8M18 21V15M15 18H21" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

const consentIcon = () =>{
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M16 4C16.93 4 17.395 4 17.7765 4.10222C18.8117 4.37962 19.6204 5.18827 19.8978 6.22354C20 6.60504 20 7.07003 20 8V17.2C20 18.8802 20 19.7202 19.673 20.362C19.3854 20.9265 18.9265 21.3854 18.362 21.673C17.7202 22 16.8802 22 15.2 22H8.8C7.11984 22 6.27976 22 5.63803 21.673C5.07354 21.3854 4.6146 20.9265 4.32698 20.362C4 19.7202 4 18.8802 4 17.2V8C4 7.07003 4 6.60504 4.10222 6.22354C4.37962 5.18827 5.18827 4.37962 6.22354 4.10222C6.60504 4 7.07003 4 8 4M9 15L11 17L15.5 12.5M9.6 6H14.4C14.9601 6 15.2401 6 15.454 5.89101C15.6422 5.79513 15.7951 5.64215 15.891 5.45399C16 5.24008 16 4.96005 16 4.4V3.6C16 3.03995 16 2.75992 15.891 2.54601C15.7951 2.35785 15.6422 2.20487 15.454 2.10899C15.2401 2 14.9601 2 14.4 2H9.6C9.03995 2 8.75992 2 8.54601 2.10899C8.35785 2.20487 8.20487 2.35785 8.10899 2.54601C8 2.75992 8 3.03995 8 3.6V4.4C8 4.96005 8 5.24008 8.10899 5.45399C8.20487 5.64215 8.35785 5.79513 8.54601 5.89101C8.75992 6 9.03995 6 9.6 6Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}


const sliderIcon = () =>{
    return (
        <svg width="100%" height="100%" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.0505 9H5.5C4.11929 9 3 7.88071 3 6.5C3 5.11929 4.11929 4 5.5 4H15.0505M8.94949 20H18.5C19.8807 20 21 18.8807 21 17.5C21 16.1193 19.8807 15 18.5 15H8.94949M3 17.5C3 19.433 4.567 21 6.5 21C8.433 21 10 19.433 10 17.5C10 15.567 8.433 14 6.5 14C4.567 14 3 15.567 3 17.5ZM21 6.5C21 8.433 19.433 10 17.5 10C15.567 10 14 8.433 14 6.5C14 4.567 15.567 3 17.5 3C19.433 3 21 4.567 21 6.5Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )

}

export const componentTypes = {
    text: {
      category: "core",
      name: "Text",
      icon: textIcon,
      description: "A simple text component",
      supportsConditionals: true,
      properties: {
        question: { type: "string", default: "" },
        description:{type:"string",default:""},
        qualifier: { type: "string", default: "" },
        "Allow skip": { type: "boolean", default: false, description: "Allow the user to skip this question" },
      },
      // Conditional metadata
      conditionalConfig: {
        hasScore: false, // no numeric value
        allowedConditionals: { skip: false, followup: false },
      }
    },
  
    likert: {
      category: "core",
      name: "Likert Scale",
      icon: likertIcon,
      description: "A Likert Scale component",
      supportsConditionals: true,
      properties: {
        question: { type: "string", default: "" },
        description:{type:"string",default:""},
        qualifier: { type: "string", default: "" },
        "Allow skip": { type: "boolean", default: false, description: "Allow the user to skip this question" },
        scale: { type: "select", default: 5, options: [5, 7] },
        scaleLabels: { 
          type: "likertLabels", 
          default: [
            "Strongly Disagree", 
            "Disagree",
            "Neutral",
            "Agree",
            "Strongly Agree"
          ] 
        }
      },
      conditionalConfig: {
        hasScore: true,
        allowedConditionals: { skip: true, followup: true },
        operatorRequired: true, // numeric operator makes sense
        thresholdType: "numeric",
      }
    },
    slider: {
        category: "core",
        name: "Slider Scale",
        icon: sliderIcon,
        description: "A slider scale component",
        supportsConditionals: true,
        properties: {
          question: { type: "string", default: "" },
          description:{type:"string",default:""},
          qualifier: { type: "string", default: "" },
          "Allow skip": { type: "boolean", default: false, description: "Allow the user to skip this question" },
          scale: { type: "select", default: 5, options: [5, 7] },
          scaleLabels: { 
            type: "likertLabels", 
            default: [
              "Strongly Disagree", 
              "Disagree",
              "Neutral",
              "Agree",
              "Strongly Agree"
            ] 
          }
        },
        conditionalConfig: {
          hasScore: true,
          allowedConditionals: { skip: true, followup: true },
          operatorRequired: true, // numeric operator makes sense
          thresholdType: "numeric",
        }
      },
    
    dropdown: {
      category: "core",
      name: "Select",
      icon: dropdownIcon,
      description: "A dropdown component",
      supportsConditionals: true,
      properties: {
        question: { type: "string", default: "" },
        description:{type:"string",default:""},
        qualifier: { type: "string", default: "" },
        "Allow skip": { type: "boolean", default: false, description: "Allow the user to skip this question" },
        category: { type: "string", default: "" }, // New property to link to a category
        "Allow multiple selections": { type: "boolean", default: false },
        "Add 'Other (specify own)' option": { type: "boolean", default: false, description: "Add a special option that lets users provide their own custom answer" },
        options: { type: "selectOptions", default: [] }
      },
      conditionalConfig: {
        hasScore: false,
        allowedConditionals: { skip: true, followup: true },
        operatorRequired: false,
        thresholdType: "array",
        followupMode: "options", 
      }
    },
    consent: {
        category: "additional", // <--- NEW
        name: "Consent",
        icon: consentIcon,
        description: "A consent screen with text and checkboxes",
        supportsConditionals: false, // no conditionals
        properties: {
          /**
           * We'll store the "blocks" (text or checkbox) in an array of objects.
           * Example item:
           *   { type: "text", content: "Consent text goes here" }
           *   { type: "checkbox", label: "I agree to the terms", required: true }
           *
           * The user can add as many as they want and reorder them in your custom editor.
           */
          blocks: {
            type: "array",
            default: [
              { type: "text", content: "Please read and agree to the following:" },
              { type: "checkbox", label: "I agree to the above", required: true }
            ]
          }
        }
      },
      information: {
        category: "additional", // <--- NEW
        name: "Information",
        icon: informationIcon,
        description: "An information screen with various text blocks",
        supportsConditionals: false, // no conditionals
        properties: {
          /**
           * Similarly, an array describing the text elements:
           *   { type: "heading", level: "h2", content: "Important Information" }
           *   { type: "paragraph", content: "Here is some more info..." }
           */
          blocks: {
            type: "array",
            default: [
              { type: "heading", level: "h2", content: "Information Heading" },
              { type: "paragraph", content: "Detailed information goes here..." }
            ]
          }
        }
      },
      end_screen: {
        category: "additional", // <--- NEW
        name: "End Screens",
        icon: informationIcon,
        description: "An information screen with various text blocks",
        supportsConditionals: false, // no conditionals
        properties: {
          /**
           * Similarly, an array describing the text elements:
           *   { type: "heading", level: "h2", content: "Important Information" }
           *   { type: "paragraph", content: "Here is some more info..." }
           */
          blocks: {
            type: "array",
            default: [
              { type: "heading", level: "h2", content: "Information Heading" },
              { type: "paragraph", content: "Detailed information goes here..." }
            ]
          }
        }
      }
  };
  